module.exports = __webpack_public_path__ + "static/media/61850trans2.c0387d92.png";